export default __webpack_public_path__ + "static/media/credit@2x.d3bc01ff.png";